import { render, staticRenderFns } from "./ExcludedSites.html?vue&type=template&id=f8980824&scoped=true&"
import script from "./ExcludedSites.vue?vue&type=script&lang=js&"
export * from "./ExcludedSites.vue?vue&type=script&lang=js&"
import style0 from "./ExcludedSites.vue?vue&type=style&index=0&id=f8980824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8980824",
  null
  
)

export default component.exports